const validWording = "Please enter valid "
const pleaseEnterWording = "Please enter "
const selectWording = "Please select "

//common
export const futureTimeErrorMsg = "Future time is not allowed"
export const futureDateErrorMsg = "Future date is not allowed"
export const DOB = validWording + "Date of Birth"
export const postalCode = validWording + "Postal Code"
export const address = validWording + "Address"
export const unitNo = validWording + "Unit Number"
export const familyLeft = validWording + "family has the Deceased left"
export const digitOnly = pleaseEnterWording + "digit only"

//index
export const policyNumberErrorMsg =
  pleaseEnterWording + "8 character policy number starting with ‘A’"
export const claimantName = validWording + "Name of Policyholder"
export const claimantEmail = validWording + "Email Address"
export const claimantNricNumber = validWording + "NRIC/FIN No"
export const policyHolderAddress = pleaseEnterWording + "policy holder address"
export const petName = validWording + "Pet Name"
export const petGender = validWording + "Pet Gender"
export const petMicrochipNumber = validWording + "Pet Microchip Number"
export const petDateofBirth = validWording + "Pet Date Of Birth"
export const petTypeofBreed = validWording + "Pet Type Of Breed"
export const claimAmount = validWording + "claim amount"

// export const policyNumberLength =
//   pleaseEnterWording + "8 character policy number"
// export const policyNumberRequired = pleaseEnterWording + "policy number"
// export const policyNumber =
//   pleaseEnterWording + "8 character policy number starting with ‘F’"
// export const policyHolderName =
//   validWording + "Name of Insured as per policy schedule"
// export const claimantName = validWording + "Name"
// export const claimantNricNumber = validWording + "NRIC/Passport Number"
// export const claimantMobile = validWording + "Contact Number"
// export const claimantEmail = validWording + "Email Address"

//Details of Claimant
export const claimantPostalCode = validWording + "Postal Code"
export const claimantAddress = validWording + "Address"
export const claimantUnitNum = validWording + "Unit Number"
export const claimantMobile = validWording + "Contact Number"

//Claim Details
export const lossDate = validWording + "Date property was last seen"
export const lossTime = validWording + "Time property was last seen"
export const damageDate = validWording + "Date of damage"
export const damageTime = validWording + "Time of damage"
export const claimableAmount = validWording + "Claimable Amount"

export const occurrenceDescription =
  validWording + "State full circumstances of loss / damage"
export const hasInsurance = selectWording + " insured with another insurance company or not"
export const claimInsurance = selectWording + " claim from another insurer or not"
export const insuranceCompanyName = validWording + "Name of insurance company"
export const insuranceCompanyAddr =
  validWording + "Address of insurance company"
export const insuranceType = validWording + "Type of insurance"
export const policyNumber = validWording + "Policy number"
export const sumInsured = validWording + "Sum insured"

export const insCompanyName = validWording + "Name of insurance company"
export const claimDate = validWording + "Date claim was filed"
export const lossReason = validWording + "Nature of loss"
export const paidAmount = validWording + "Amount paid"
export const nameOfPoliceStation = validWording + "Name of station"

//Loss detail
export const  claimType  = validWording + "Claim Type"
export const  diagnosis  = validWording + "Current Diagnosis"
export const  symptomsStartDate  = validWording + "Date of symptoms started (dd/mm/yyyy)"
export const  firstTreatedDate  = validWording + "Date of first treated (dd/mm/yyyy)"
export const  lastFirstTreatedDate  = validWording + "Date of first treatment "
export const  lastVeterinarianName  = validWording + "Veterinarian Name"
export const  lastVeterinarianAddress  = validWording + "Veterinarian Address"
export const  accidentType  = validWording + "Accident Type"
export const  accidentTypeDescription  = validWording + "Accident Type Description"
export const  accidentDate  = validWording + "Date of Accident"
export const  accidentCircumstance  = validWording + "Circumstances of Accident "
export const  natureOfInjuries  = validWording + "details of the nature of injuries sustained"
export const  dateOfDeath  = validWording + "Date of death"
export const  deathCause  = validWording + "Cause of death"
export const  incidentNotifiedDate  = validWording + "Date being notified of the incident"
export const  incidentPlace  = validWording + "Place incident happen"
export const  incidentDetails  = validWording + "Details of the incident"

export const  injuredMobile  = validWording + "Contact Number of injured person"
export const  injuredEmail  = validWording + "Email of injured person"
export const  damageMobile  = validWording + "Contact Number"
export const  damageEmail  = validWording + "Email"

//Gigacover Particulars
export const propertyMake = validWording + "Make of Property"
export const propertyModel = validWording + "Model of Property"
export const damageDescription = validWording + "Description of Damage"
export const otherMajorRelatedInfo =
  validWording + "Other repair-related information"
export const estRepairReplacementCost =
  validWording + "Estimated Repair/Replacement Cost"
export const description = validWording + "description"

//payment details
export const bankName = validWording + "Name of Bank"
export const accountNumber = validWording + "Bank Account Number"
export const accountName = validWording + "Name of Account Holder"
export const accountNRIC = validWording + "NRIC"
